// js/common/utilities/format-money.js
function formatMoney(cents, format = "") {
  if (typeof cents === "string") {
    cents = cents.replace(".", "");
  }
  const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/, formatString = format || window.settings.moneyFormat;
  function defaultTo(value2, defaultValue) {
    return value2 == null || value2 !== value2 ? defaultValue : value2;
  }
  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultTo(precision, 2);
    thousands = defaultTo(thousands, ",");
    decimal = defaultTo(decimal, ".");
    if (isNaN(number) || number == null) {
      return 0;
    }
    number = (number / 100).toFixed(precision);
    let parts = number.split("."), dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands), centsAmount = parts[1] ? decimal + parts[1] : "";
    return dollarsAmount + centsAmount;
  }
  let value = "";
  switch (formatString.match(placeholderRegex)[1]) {
    case "amount":
      value = formatWithDelimiters(cents, 2);
      break;
    case "amount_no_decimals":
      value = formatWithDelimiters(cents, 0);
      break;
    case "amount_with_space_separator":
      value = formatWithDelimiters(cents, 2, " ", ".");
      break;
    case "amount_with_comma_separator":
      value = formatWithDelimiters(cents, 2, ".", ",");
      break;
    case "amount_with_apostrophe_separator":
      value = formatWithDelimiters(cents, 2, "'", ".");
      break;
    case "amount_no_decimals_with_comma_separator":
      value = formatWithDelimiters(cents, 0, ".", ",");
      break;
    case "amount_no_decimals_with_space_separator":
      value = formatWithDelimiters(cents, 0, " ");
      break;
    case "amount_no_decimals_with_apostrophe_separator":
      value = formatWithDelimiters(cents, 0, "'");
      break;
    default:
      value = formatWithDelimiters(cents, 2);
      break;
  }
  if (formatString.indexOf("with_comma_separator") !== -1) {
    return formatString.replace(placeholderRegex, value);
  } else {
    return formatString.replace(placeholderRegex, value);
  }
}
var currencyFormat = window.settings.currencyCodeEnabled ? window.settings.moneyWithCurrencyFormat : window.settings.moneyFormat;
class configuratorDrawer extends HTMLElement {
  constructor() {
    super();
    var temp_this = this;
    this.addEventListener(
      'keyup',
      (evt) => evt.code === 'Escape' && this.close()
    );
    this.querySelector('#configuratorDrawer-Overlay').addEventListener(
      'click',
      this.close.bind(this)
    );
    this.setHeaderCartIconAccessibility();

    //remove hide on first load, this is added to prevent showing a white space on top when first load the page
    this.parentElement.classList.remove('hide-on-first-load');

    let flockOptions = temp_this.querySelectorAll('.flock-options input[name="flock-option"]');
    flockOptions.forEach(function (option) {
      option.addEventListener('click', (event) => {
        temp_this.updateFormInput(event.target);
        temp_this.updateJerseyFlock(event);
        temp_this.toggleFlockHandler(event);
        temp_this.syncBadgeOptions();
      })
    })

    window.addEventListener('click', function (event) {
      const inside = event.target.closest('.flock-players-options');
      if (!inside) {
        temp_this.togglePlayersDropdown(event, true);
      }
    });
    temp_this.querySelectorAll('.flock-players-options .selected-name-container').forEach(function (el) {
      el.addEventListener('click', function (event) {
        temp_this.togglePlayersDropdown(event);
      });
    });

    temp_this.querySelectorAll('.flock-players-options ul li').forEach(function (option) {
      option.addEventListener('click', (event) => {
        temp_this.pickPlayer(event)
      });
    })

    let drawerAction = temp_this.querySelectorAll('.drawer__footer .button');
    drawerAction.forEach(function (button) {
      button.addEventListener('click', (event) => {
        temp_this.configuratorAction(event);
      })
    })
    if (temp_this.querySelector('.personalize-inputs #flock-personalize-name'))
      temp_this.querySelector('.personalize-inputs #flock-personalize-name').addEventListener('keyup', function (event) {
        temp_this.writeNameOnJersey('', event);
        temp_this.updateInputMaxLenText(event);
      })

    if (temp_this.querySelector('.personalize-inputs #flock-personalize-number'))
      temp_this.querySelector('.personalize-inputs #flock-personalize-number').addEventListener('keyup', function (event) {
        temp_this.writeNumberOnJersey('', event, temp_this);
        temp_this.updateInputMaxLenText(event, true);
      })

    let badgesOptions = temp_this.querySelectorAll('.badge-options input[name="badge-option"]');
    badgesOptions.forEach(function (badge) {
      badge.addEventListener('click', function (event) {
        temp_this.addBadgeOnJersey(event);
        temp_this.updateFormInput(event.target);
      })
    })

    this.syncBadgeOptions();
  }

  // Determine if a selected flock option corresponds to the personalized option.
  // This avoids relying on hard-coded IDs like "flock-3" which can change when options are added.
  isPersonalizeSelectedById(optionId) {
    const optionBlock = this.querySelector('#' + optionId + '-option');
    if (optionBlock) {
      return optionBlock.classList.contains('flock-personalize') || !!optionBlock.querySelector('.personalize-inputs');
    }
    // No explicit block found for this option id; treat as non-personalized.
    return false;
  }

  // Determine if a selected flock option is one of the player selection options (with dropdown)
  isPlayersOptionById(optionId) {
    const optionBlock = this.querySelector('#' + optionId + '-option');
    return !!(optionBlock && optionBlock.classList.contains('flock-players-options'));
  }

  normalizeBadgeGroup(value, fallback = 'male') {
    const normalizedValue = String(value || '').trim().toLowerCase();
    if (normalizedValue === 'none' || normalizedValue === 'ohne') {
      return 'none';
    }
    if (normalizedValue.indexOf('female') !== -1 || normalizedValue.indexOf('frau') !== -1 || normalizedValue.indexOf('women') !== -1) {
      return 'female';
    }
    if (normalizedValue.indexOf('male') !== -1 || normalizedValue.indexOf('mann') !== -1 || normalizedValue.indexOf('men') !== -1) {
      return 'male';
    }
    return fallback;
  }

  getSelectedFlockBadgeGroup() {
    const selectedFlock = this.querySelector('.flock-options input[name="flock-option"]:checked');
    if (!selectedFlock) {
      return 'both';
    }
    return this.normalizeBadgeGroup(selectedFlock.dataset.badgeGroup, selectedFlock.id === 'flock-0' ? 'none' : 'both');
  }

  shouldShowBadgeOption(flockGroup, badgeGroup) {
    if (badgeGroup === 'none') {
      return flockGroup === 'none';
    }
    if (flockGroup === 'male') {
      return badgeGroup === 'male';
    }
    if (flockGroup === 'female') {
      return badgeGroup === 'female';
    }
    return true;
  }

  syncBadgeOptions() {
    const badgeOptions = Array.from(this.querySelectorAll('.badge-options input[name="badge-option"]'));
    if (!badgeOptions.length) {
      return;
    }

    const maleBadgeGroup = this.querySelector('.badge-group--male');
    const femaleBadgeGroup = this.querySelector('.badge-group--female');
    const flockGroup = this.getSelectedFlockBadgeGroup();
    const hasMaleBadges = badgeOptions.some(function(option) {
      return this.normalizeBadgeGroup(option.dataset.badgeGroup, option.id === 'badge-0' ? 'none' : 'male') === 'male';
    }.bind(this));
    const hasFemaleBadges = badgeOptions.some(function(option) {
      return this.normalizeBadgeGroup(option.dataset.badgeGroup, option.id === 'badge-0' ? 'none' : 'male') === 'female';
    }.bind(this));
    let effectiveFlockGroup = flockGroup;
    if (flockGroup === 'female' && !hasFemaleBadges && hasMaleBadges) {
      effectiveFlockGroup = 'male';
    }
    if (flockGroup === 'male' && !hasMaleBadges && hasFemaleBadges) {
      effectiveFlockGroup = 'female';
    }

    console.log('rick', effectiveFlockGroup, maleBadgeGroup, femaleBadgeGroup);

    if (maleBadgeGroup) {
      maleBadgeGroup.style.display = effectiveFlockGroup === 'female' ? 'none' : '';
    }
    if (femaleBadgeGroup) {
      femaleBadgeGroup.style.display = effectiveFlockGroup === 'male' ? 'none' : '';
    }

    let checkedVisibleOption = null;
    let firstVisibleOption = null;
    let firstVisibleBadgeOption = null;

    badgeOptions.forEach(function(option) {
      const label = this.querySelector('.badge-options label[for="' + option.id + '"]');
      const defaultGroup = option.id === 'badge-0' ? 'none' : 'male';
      const badgeGroup = this.normalizeBadgeGroup(option.dataset.badgeGroup, defaultGroup);
      const shouldShow = this.shouldShowBadgeOption(effectiveFlockGroup, badgeGroup);

      option.style.display = shouldShow ? '' : 'none';
      if (label) {
        label.style.display = shouldShow ? '' : 'none';
      }

      if (shouldShow) {
        if (!firstVisibleOption) {
          firstVisibleOption = option;
        }
        if (badgeGroup !== 'none' && !firstVisibleBadgeOption) {
          firstVisibleBadgeOption = option;
        }
        if (option.checked) {
          checkedVisibleOption = option;
        }
      }
    }.bind(this));

    let targetOption = checkedVisibleOption;
    if (!targetOption) {
      targetOption = effectiveFlockGroup === 'none' ? firstVisibleOption : firstVisibleBadgeOption || firstVisibleOption;
    }

    if (targetOption) {
      targetOption.checked = true;
      this.addBadgeOnJersey({ target: targetOption });
      this.updateFormInput(targetOption);
    } else {
      this.clearJerseyBadges();
      this.removeFormInput(false, true);
    }

    this.updatePrice();
  }

  updateInputMaxLenText(triggeredEvent, isNumber = false) {
    if (triggeredEvent == null) {
      this.querySelector('.personalize-inputs #flock-personalize-name').nextElementSibling ? this.querySelector('.personalize-inputs #flock-personalize-name').nextElementSibling.innerHTML = '0/13' : '';
      this.querySelector('.personalize-inputs #flock-personalize-number').nextElementSibling ? this.querySelector('.personalize-inputs #flock-personalize-number').innerHTML = '0/2' : '';
    } else {
      let maxLen = isNumber ? 2 : 13;
      triggeredEvent.target.nextElementSibling ? triggeredEvent.target.nextElementSibling.innerHTML = triggeredEvent.target.value.length + '/' + maxLen : '';
    }
  }

  updatePrice() {
    let productFormID = document.querySelector('.product-configurator-block') ? document.querySelector('.product-configurator-block').getAttribute('form-id') : '';
    let productSectionID = document.querySelector('.product-configurator-block') ? document.querySelector('.product-configurator-block').getAttribute('section-id') : '';
    if (productFormID) {
      let badgePrice = document.querySelector('form[id="' + productFormID + '"] input[name="badge-option"]') ? document.querySelector('form[id="' + productFormID + '"] input[name="badge-option"]').getAttribute('variant-price') : 0;
      let flockPrice = document.querySelector('form[id="' + productFormID + '"] input[name="flock-option"]') ? document.querySelector('form[id="' + productFormID + '"] input[name="flock-option"]').getAttribute('variant-price') : 0;
      let currentVariantPriceElem = document.querySelectorAll('#ProductInfo-' + productSectionID + ' .original-price');

      let productID = document.querySelector('.product-configurator-block')?.getAttribute('product-id') ? document.querySelector('.product-configurator-block').getAttribute('product-id') : '';
      let playerName = document.querySelector('form[id="' + productFormID + '"] input[name="flock-option"]') ? document.querySelector('form[id="' + productFormID + '"] input[name="flock-option"]').getAttribute('player-name') : '';
      let badgeID = document.querySelector('.configurator-blocks-container input[name="badge-option"]') ? document.querySelector('.configurator-blocks-container input[name="badge-option"]').getAttribute('product-id') : '';
      let flockID = document.querySelector('.configurator-blocks-container input[name="flock-option"]') ? document.querySelector('.configurator-blocks-container input[name="flock-option"]').getAttribute('product-id') : '';

      currentVariantPriceElem.forEach(function (priceElem) {
        if(priceElem.closest('.product-info-price')){
          let currentVariantPrice = parseInt(priceElem.getAttribute('variant-price')) || 0;

          const scriptDiscount = document.querySelector('script[jersey-discount-json-data]');
          const discounts = scriptDiscount ? JSON.parse(scriptDiscount.textContent) : null;

          let badgePriceInt = parseInt(badgePrice) || 0;
          let flockPriceInt = parseInt(flockPrice) || 0;

          let discountedBadgePrice = badgePriceInt;
          let discountedFlockPrice = flockPriceInt;

          try {
            if (typeof discounts !== 'undefined' && Array.isArray(discounts.discounts) && typeof productID !== 'undefined' && typeof playerName !== 'undefined') {
              const matched = discounts.discounts.filter(function(rule) {
                return String(rule.trigger_product_id) === String(productID) &&
                       String(rule.trigger_attribute_value).toLowerCase() === String(playerName).toLowerCase();
              });
              if (matched.length > 0) {
                let badgeDiscountPct = 0;
                let flockDiscountPct = 0;

                matched.forEach(function(rule) {
                  const pctRaw = parseFloat(rule.discount_percentage);
                  const pct = isNaN(pctRaw) ? 0 : Math.max(0, Math.min(100, pctRaw));

                  if (typeof badgeID !== 'undefined' && String(rule.discount_product_id) === String(badgeID)) {
                    badgeDiscountPct = Math.max(badgeDiscountPct, pct);
                  }
                  if (typeof flockID !== 'undefined' && String(rule.discount_product_id) === String(flockID)) {
                    flockDiscountPct = Math.max(flockDiscountPct, pct);
                  }
                });

                if (badgeDiscountPct > 0) {
                  discountedBadgePrice = Math.round(badgePriceInt * (1 - badgeDiscountPct / 100));
                }
                if (flockDiscountPct > 0) {
                  discountedFlockPrice = Math.round(flockPriceInt * (1 - flockDiscountPct / 100));
                }
              }
            }
          } catch (e) {
            // fail silently if discount data is not available or malformed
          }
          var totalCents = discountedBadgePrice + discountedFlockPrice + currentVariantPrice;
          priceElem.innerHTML = formatMoney(totalCents, currencyFormat);
        }
      })
    }
  }

  updateFormInput(triggeredEventTarget) {
    if (triggeredEventTarget.id === 'flock-0') {
      this.removeFormInput(true, false);
    }
    else if (triggeredEventTarget.id === 'badge-0') {
      this.removeFormInput(false, true);
    }
    else {
      let selectedOptionVID = triggeredEventTarget.getAttribute('variant-id');
      let selectedOptionPrice = triggeredEventTarget.getAttribute('variant-price');
      let productFormID = document.querySelector('.product-configurator-block') ? document.querySelector('.product-configurator-block').getAttribute('form-id') : '';
      if (productFormID) {
        if (document.querySelector('form[id="' + productFormID + '"] input[name="' + triggeredEventTarget.name + '"]')) {
          document.querySelector('form[id="' + productFormID + '"] input[name="' + triggeredEventTarget.name + '"]').value = selectedOptionVID;
          document.querySelector('form[id="' + productFormID + '"] input[name="' + triggeredEventTarget.name + '"]').setAttribute('variant-price', selectedOptionPrice);
          document.querySelector('form[id="' + productFormID + '"] input[name="' + triggeredEventTarget.name + '"]').setAttribute('data-title', triggeredEventTarget.value)
          if (triggeredEventTarget.name != 'badge-option') {
            const isPersonalized = this.isPersonalizeSelectedById(triggeredEventTarget.id);
            document.querySelector('form[id="' + productFormID + '"] input[name="' + triggeredEventTarget.name + '"]').setAttribute('is-individuell', isPersonalized ? true : false);
          }
        }
        else {
          let inputNode = document.createElement("input");
          inputNode.type = "hidden";
          inputNode.name = triggeredEventTarget.name;
          inputNode.value = selectedOptionVID;
          inputNode.setAttribute('variant-price', selectedOptionPrice);
          inputNode.setAttribute('data-title', triggeredEventTarget.value)

          if (triggeredEventTarget.name != 'badge-option') {
            const isPersonalized = this.isPersonalizeSelectedById(triggeredEventTarget.id);
            inputNode.setAttribute('is-individuell', isPersonalized ? true : false);
          }
          document.querySelector('form[id="' + productFormID + '"]').appendChild(inputNode);
        }
      }
    }
  }

  removeFormInput(isFlock = true, isBadge = true) {
    let productFormID = document.querySelector('.product-configurator-block') ? document.querySelector('.product-configurator-block').getAttribute('form-id') : '';
    isFlock && document.querySelector('form[id="' + productFormID + '"] input[name="flock-option"]') ? document.querySelector('form[id="' + productFormID + '"] input[name="flock-option"]').remove() : '';
    isBadge && document.querySelector('form[id="' + productFormID + '"] input[name="badge-option"]') ? document.querySelector('form[id="' + productFormID + '"] input[name="badge-option"]').remove() : '';
  }

  // Adds badge on overlay
  // addBadgeOnJersey(triggeredEvent) {
  //   if (triggeredEvent.target.id === 'badge-0') {
  //     this.clearJerseyBadges();
  //   } else {
  //     let badgeElem = this.querySelector('.badge-options label[for="' + triggeredEvent.target.id + '"] span');
  //     this.querySelector('.configurator-image .custom-badge-overlay').innerHTML = badgeElem.outerHTML;
  //     this.showJerseyImagePreview();
  //     this.updateBadgeOnProductPreview();
  //   }
  // }

  // Updates the whole jersey image having the badge in it.
  addBadgeOnJersey(triggeredEvent) {
    this.clearJerseyBadges();

    const badgeOption = triggeredEvent.target;
    const jerseyImage = document.querySelector('.configurator-image .jersey-image');

    const imageUrl = badgeOption.getAttribute('data-image-url');
    if (imageUrl && jerseyImage) {
      jerseyImage.srcset = '';
      jerseyImage.src = imageUrl;
    }

    this.showJerseyImagePreview();
    this.updateBadgeOnProductPreview();
  }

  updateJerseyFlock(triggeredEvent) {
    const optionId = triggeredEvent.target.id;
    if (this.isPlayersOptionById(optionId)) {
      const container = this.querySelector('#' + optionId + '-option');
      const selectedInfo = container ? container.querySelector('.selected-player-name .player-info') : null;
      this.changePersonalized(
        selectedInfo ? selectedInfo.getAttribute('number') : '',
        selectedInfo ? selectedInfo.getAttribute('name') : ''
      );
    } else if (this.isPersonalizeSelectedById(optionId)) {
      this.changePersonalized(
        this.querySelector('.personalize-inputs input#flock-personalize-number') ? this.querySelector('.personalize-inputs input#flock-personalize-number').value : '',
        this.querySelector('.personalize-inputs input#flock-personalize-name') ? this.querySelector('.personalize-inputs input#flock-personalize-name').value : '',
        true
      )
    } else {
      this.clearJerseyPersonalizedData();
    }
  }

  changePersonalized(number = '', name = '', canBeEmpty = false) {
    if (number != '') {
      this.writeNumberOnJersey(number, '', this);
    }
    else if (canBeEmpty) {
      this.clearJerseyPersonalizedData(false, true);
    }
    if (name != '') {
      this.writeNameOnJersey(name, '', this);
    }
    else if (canBeEmpty) {
      this.clearJerseyPersonalizedData(true, false);
    }
    this.updateFormPersonalizedInput(number, name);
  }

  updateFormPersonalizedInput(number = null, name = null) {
    let productFormID = document.querySelector('.product-configurator-block') ? document.querySelector('.product-configurator-block').getAttribute('form-id') : '';
    if (name !== null && document.querySelector('form[id="' + productFormID + '"] input[name="flock-option"]'))
      document.querySelector('form[id="' + productFormID + '"] input[name="flock-option"]').setAttribute('player-name', name);
    if (number !== null && document.querySelector('form[id="' + productFormID + '"] input[name="flock-option"]'))
      document.querySelector('form[id="' + productFormID + '"] input[name="flock-option"]').setAttribute('player-number', number);
  }

  clearJerseyPersonalizedData(nameOnly = false, numberOnly = false) {
    if (!numberOnly) {
      const nameContainer = this.querySelector('.personalized-flock .name');
      if (nameContainer) {
        nameContainer.innerHTML = '';
        // Reset curved text styles and data attribute
        nameContainer.removeAttribute('data-original-name');
        nameContainer.style.minWidth = '';
        nameContainer.style.minHeight = '';
      }
    }
    if (!nameOnly) {
      const numberContainer = this.querySelector('.personalized-flock .number');
      if (numberContainer) {
        numberContainer.innerHTML = '';
      }
    }

    // Also clear the product preview
    const productPreviewFlock = document.querySelector('.product__media-list .product__media .personalized-flock');
    if (productPreviewFlock) {
      if (!numberOnly) {
        const productName = productPreviewFlock.querySelector('.name');
        if (productName) {
          productName.innerHTML = '';
          productName.removeAttribute('data-original-name');
          productName.style.minWidth = '';
          productName.style.minHeight = '';
        }
      }
      if (!nameOnly) {
        const productNumber = productPreviewFlock.querySelector('.number');
        if (productNumber) {
          productNumber.innerHTML = '';
        }
      }
    }
  }

  writeNameOnJersey(name = '', triggeredEvent = '') {
    let germanSpecialCharSvg =
      '<span class="specialCharFont"><svg xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="240 170 535 670" style="&#10;    width: auto;&#10;    height: 8.5px;&#10;">\
      <g>\
        <g id="Ebene_1">\
          <path class="cls-1" d="M762.2,673.5v-23.7c0-28.5-6.5-52.2-19.5-71.2-13-19-31.5-36.4-55.6-52.2l-102.6-72.5,64.1-170.4v-114.3h-281c-86.5,11.6-129.7,64.3-129.7,158v6.6l.2,493.4h144.4l-.2-491.8c0-30.4,16.1-45.6,48.4-45.6s35.8,0,57.2,0,12.6,19.8,12.6,19.8l-3.1,8-40.3,102.9s-9,18.6-9,32.9v21.1c0,35.7,26.3,60.8,63.7,86.1,65.2,43.1,90.6,68.4,98.2,76,6.3,5.7,9.5,13.3,9.5,22.8v8.5c0,12-5.9,21.1-17.6,27.1-11.7,6-35.6,9-71.7,9s-69-4.4-98.8-13.3v128.2c34.2,8.2,75.3,12.3,123.5,12.3,138,0,207-52.5,207-157.7h0Z"/>\
        </g>\
      </g>\
    </svg></span>';

    const nameContainer = this.querySelector('.personalized-flock .name');
    const isCurved = nameContainer.classList.contains('curved');
    let displayName = name !== '' ? name : this.validateNameInput(triggeredEvent);

    // Store the original name as a data attribute (needed for product preview since SVG has no textContent)
    nameContainer.setAttribute('data-original-name', displayName);

    if (isCurved && displayName) {
      // this.applyCurvedText(nameContainer, displayName, germanSpecialCharSvg, 1000);
      this.updateCurvedText(nameContainer, displayName, 100, 2, germanSpecialCharSvg);
    } else {
      nameContainer.innerHTML = displayName.replace('ß', germanSpecialCharSvg);
    }

    this.updateFormPersonalizedInput(null, displayName);
    this.showJerseyImagePreview();
    this.updateFlockOnProductPreview();
  }

  updateCurvedText(curvedText, displayName, baseRadius = 100, baseLetterSpacing = 2, germanSpecialCharSvg = '') {
    const text = displayName;
    const textLength = text.length;

    // Dynamic radius: shorter words get smaller radius (more curve)
    // Longer words get larger radius (less curve)
    const radius = Math.max(60, baseRadius + (textLength - 5) * 15);

    // Letter spacing in pixels
    const letterSpacing = baseLetterSpacing;

    // Reset min sizes
    curvedText.style.minWidth = "initial";
    curvedText.style.minHeight = "initial";
    curvedText.textContent = displayName;

    let h = curvedText.offsetHeight;
    if(h > 30 && window.innerWidth < 750) h = 30

    curvedText.style.minHeight = h + "px";

    let html = "";
    Array.from(text).forEach(letter => {
      if (letter === 'ß' && germanSpecialCharSvg) {
        html += `<span>${germanSpecialCharSvg}</span>`;
      } else {
        html += `<span>${letter}</span>`;
      }
    });
    curvedText.innerHTML = html;

    // Only select direct child spans (not nested ones like .specialCharFont inside the ß SVG)
    const letters = curvedText.querySelectorAll(":scope > span");

    // Track which letters are special chars and their widths
    const specialCharWidths = new Map();

    // First, make letters visible to measure their widths
    letters.forEach((letter, idx) => {
      letter.style.position = "absolute";
      letter.style.height = `${radius}px`;
      letter.style.transformOrigin = "center bottom";

      // Fix positioning for ß SVG - scale offset based on baseRadius
      // At baseRadius 100: top=-1px, left=2px | At baseRadius 250: top=3px, left=6px
      const specialChar = letter.querySelector('.specialCharFont');
      if (specialChar) {
        // Set explicit width on the ß span - store it for later use
        // The width should scale with baseRadius (similar to how regular letter font-size scales)
        const charWidth = Math.round(6 + (baseRadius - 100) * 0.04); // ~6px at 100, ~12px at 250
        letter.style.width = `${charWidth}px`;
        specialCharWidths.set(idx, charWidth); // Store the width we set

        specialChar.style.position = "absolute";
        // Linear interpolation: offset scales proportionally with baseRadius
        const scaleFactor = (baseRadius - 100) / 150; // 0 at radius 100, 1 at radius 250
        const isMobile = window.innerWidth < 750;
        const topOffset = isMobile
          ? Math.round(-1 + scaleFactor * 2)  // -1px to 1px on mobile
          : Math.round(-1 + scaleFactor * 4); // -1px to 3px on desktop
        const leftOffset = isMobile
          ? Math.round(scaleFactor * 1)  // 0px to 1px on mobile
          : Math.round(scaleFactor * 2); // 0px to 2px on desktop
        specialChar.style.top = `${topOffset}px`;
        specialChar.style.left = `${leftOffset}px`;
      }
    });

    // Calculate individual letter widths and total arc width
    const letterWidths = [];
    let totalWidth = 0;

    letters.forEach((letter, idx) => {
      // Use stored width for special chars, otherwise measure
      const width = specialCharWidths.has(idx) ? specialCharWidths.get(idx) : letter.offsetWidth;
      letterWidths.push(width);
      totalWidth += width;
      if (idx < textLength - 1) {
        totalWidth += letterSpacing;
      }
    });

    // Calculate total arc angle
    const totalArcAngle = (totalWidth / radius) * (180 / Math.PI);

    // Position each letter based on its accumulated width
    let currentAngle = -totalArcAngle / 2;
    let halfLength = (letters.length)/2;

    letters.forEach((letter, idx) => {
      // Calculate the angle for this letter's center
      const letterWidth = letterWidths[idx];
      const letterAngle = (letterWidth / radius) * (180 / Math.PI);
      const centerAngle = currentAngle + (letterAngle / 2);

      // Apply special offset for narrow letters like i, I, j, J
      let offset = 0;
      if (letter.textContent === 'i' || letter.textContent === 'I' || letter.textContent === 'J' || letter.textContent === 'j') {
        if(idx + 1 == halfLength) {
          offset = .5;
        } else {
          offset = 1;
        }
      }

      letter.style.transform = `rotate(${centerAngle + offset}deg)`;

      // Move to next letter position
      currentAngle += letterAngle;
      if (idx < textLength - 1) {
        currentAngle += (letterSpacing / radius) * (180 / Math.PI);
      }
    });

    // Update min width based on actual curved text dimensions
    curvedText.style.minWidth = totalWidth + "px";
  }



  writeNumberOnJersey(number = '', triggeredEvent = '', temp_this) {
    const flockNumbersJson = document.querySelector('[jersey-json-data]');
    const flockNumbersArr = JSON.parse(flockNumbersJson.innerHTML);
    let digits = [];
    let numbersContainer = temp_this.querySelector('.personalized-flock .number');
    let isValidNumber = true;
    let hasSquareImage = false;
    let customNumber = number !== '' ? String(number) : String(triggeredEvent.target.value);
    numbersContainer.innerHTML = '';
    numbersContainer.classList.remove('square-image');
    digits = customNumber.split('');
    if (digits.length > 1 && number === '') {
      isValidNumber = temp_this.validateNumberInput(triggeredEvent);
    }
    if (isValidNumber) {
      const flocking = flockNumbersArr.flocking || {};
      const hasCompositeNumbers = Object.keys(flocking).length > 10;
      const compositeKey = 'number_' + customNumber;

      // If theme provides composite images (more than 10) and the full number exists, use it.
      if (hasCompositeNumbers && flocking[compositeKey]) {
        const imgNum = flocking[compositeKey];
        hasSquareImage = Number(imgNum.aspect_ratio) >= 1;
        const newDiv = document.createElement('div');
        newDiv.innerHTML = imgNum && imgNum.image ? imgNum.image : customNumber;
        numbersContainer.appendChild(newDiv);
      } else {
        // Fallback to per-digit images (legacy behavior)
        digits.forEach(function (digit) {
          const imgNum = flocking['number_' + digit];
          if (imgNum != '') {
            if (!hasSquareImage) {
              hasSquareImage = Number(imgNum.aspect_ratio) >= 1;
            }
            const newDiv = document.createElement('div');
            newDiv.innerHTML = imgNum ? imgNum.image : digit;
            numbersContainer.appendChild(newDiv);
          }
        });
      }
      numbersContainer.classList.toggle('square-image', hasSquareImage);
      this.updateFormPersonalizedInput(customNumber, null);
    }
    else {
      this.updateFormPersonalizedInput('', '');
    }
    this.showJerseyImagePreview();
    this.updateFlockOnProductPreview();
  }

  showJerseyImagePreview() {
    if (document.querySelector('.image-configurator-thumbnail'))
      document.querySelector('.image-configurator-thumbnail').classList.remove('hidden');
    if (document.querySelector('.image-configurator-thumbnail button'))
      document.querySelector('.image-configurator-thumbnail button').click();
    if (document.querySelector('.configurator-image-preview'))
      document.querySelector('.configurator-image-preview').classList.remove('hidden');
  }

  updateFlockOnProductPreview() {
    //add selected flock to preview image
    const productPreviewFlock = document.querySelector('.product__media-list .product__media .personalized-flock');
    const drawerFlock = this.querySelector('.configurator-image .personalized-flock');

    // German special character SVG for ß
    const germanSpecialCharSvg =
      '<span class="specialCharFont"><svg xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="240 170 535 670" style="&#10;    width: auto;&#10;    height: 8.5px;&#10;">\
      <g>\
        <g id="Ebene_1">\
          <path class="cls-1" d="M762.2,673.5v-23.7c0-28.5-6.5-52.2-19.5-71.2-13-19-31.5-36.4-55.6-52.2l-102.6-72.5,64.1-170.4v-114.3h-281c-86.5,11.6-129.7,64.3-129.7,158v6.6l.2,493.4h144.4l-.2-491.8c0-30.4,16.1-45.6,48.4-45.6s35.8,0,57.2,0,12.6,19.8,12.6,19.8l-3.1,8-40.3,102.9s-9,18.6-9,32.9v21.1c0,35.7,26.3,60.8,63.7,86.1,65.2,43.1,90.6,68.4,98.2,76,6.3,5.7,9.5,13.3,9.5,22.8v8.5c0,12-5.9,21.1-17.6,27.1-11.7,6-35.6,9-71.7,9s-69-4.4-98.8-13.3v128.2c34.2,8.2,75.3,12.3,123.5,12.3,138,0,207-52.5,207-157.7h0Z"/>\
        </g>\
      </g>\
    </svg></span>';

    if (productPreviewFlock && drawerFlock) {
      // Copy the number (uses images, can be copied directly)
      const drawerNumber = drawerFlock.querySelector('.number');
      const productNumber = productPreviewFlock.querySelector('.number');
      if (drawerNumber && productNumber) {
        productNumber.innerHTML = drawerNumber.innerHTML;
        productNumber.classList.toggle('square-image', drawerNumber.classList.contains('square-image'));
      }

      // For the name, we need to recalculate the curve for the larger font
      const drawerName = drawerFlock.querySelector('.name');
      const productName = productPreviewFlock.querySelector('.name');
      if (drawerName && productName) {
        const isCurved = productName.classList.contains('curved');
        // Use data attribute to get original name (textContent loses 'ß' since it's an SVG)
        const displayName = drawerName.getAttribute('data-original-name') || drawerName.textContent.trim();

        if (isCurved && displayName) {
          // Use larger baseRadius and letter spacing for product preview (bigger font needs gentler curve)
          this.updateCurvedText(productName, displayName, 250, 4, germanSpecialCharSvg);
        } else {
          productName.innerHTML = drawerName.innerHTML;
        }
      }
    }
  }

  updateBadgeOnProductPreview() {
    // Add selected badge to preview image overlay
    // if (document.querySelector('.product__media-list .product__media .custom-badge-overlay'))
    //   document.querySelector('.product__media-list .product__media .custom-badge-overlay').innerHTML = this.querySelector('.configurator-image .custom-badge-overlay').innerHTML;

    // Update preview image with the selected badge
    const configuratorJerseyImage = document.querySelector('.configurator-image .jersey-image');
    const previewJerseyImage = document.querySelector('.product__media-list .product__media .jersey-image');

    const imageUrl = configuratorJerseyImage.src;
    if (imageUrl && previewJerseyImage) {
      previewJerseyImage.src = imageUrl;
      previewJerseyImage.srcset = '';
    }
  }

  setHeaderCartIconAccessibility() {
    const drawerLink = document.querySelector('#configurator-customize-button');
    drawerLink.setAttribute('role', 'button');
    drawerLink.setAttribute('aria-haspopup', 'dialog');
    drawerLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(drawerLink);
    });
    drawerLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(drawerLink);
      }
    });
  }

  validateNameInput(triggeredEvent) {
    let inputValue = triggeredEvent.target.value;
    const playerNamesBlacklistJson = document.querySelector('[jersey-json-data]');
    if (playerNamesBlacklistJson) {
      const blacklistWordsArr = JSON.parse(playerNamesBlacklistJson.innerHTML).playerNameBlacklist.split('|');
      if (blacklistWordsArr.length > 0) {
        blacklistWordsArr.forEach(function (word) {
          let wordLower = word.toLowerCase();
          let inputValueLower = inputValue.toLowerCase();
          if (inputValueLower.match(wordLower)) {
            let wordIndex = inputValueLower.indexOf(wordLower);
            let wordLength = wordLower.length;
            //to remove all blacklist in any letters combinations (Upper or lower)
            triggeredEvent.target.value = inputValue.substring(0, wordIndex) + inputValue.substring(wordIndex + wordLength, inputValue.length);
            // triggeredEvent.target.value = triggeredEvent.target.value.replace(word, '');
            return triggeredEvent.target.value;
          }
        })
      }
    }
    return triggeredEvent.target.value;
  }

  validateNumberInput(triggeredEvent) {
    let inputValue = triggeredEvent.target.value;
    const playerNumBlacklistJson = document.querySelector('[jersey-json-data]');
    const blacklistNumbersArr = JSON.parse(playerNumBlacklistJson.innerHTML).playerNumBlacklist.split('|');

    if (blacklistNumbersArr.includes(inputValue)) {
      triggeredEvent.target.value = '';
      return false;
    }
    return true;
  }

  configuratorAction(triggeredBy) {
    if (triggeredBy.target.id === 'reset-configurator') {
      this.resetConfigurator();
      this.clearJerseyPersonalizedData();
      this.clearJerseyBadges();
      this.removeFormInput();
      this.updatePrice();
      this.updateInputMaxLenText(null);
      // Trigger variant change to update button state (for legend flock)
      this.triggerVariantChange();
    } else if (triggeredBy.target.id === 'save-configurator') {
      let isRequiredFieldFilled = this.isCustomNumberFilled();
      let isPlayerSelected = this.isPlayerSelected();
      if (isRequiredFieldFilled && isPlayerSelected) {
        // Trigger variant change to update button state (for legend flock)
        this.triggerVariantChange();
        this.close(true);
      }
    }
  }

  clearJerseyBadges() {
    this.querySelector('.custom-badge-overlay') ? this.querySelector('.custom-badge-overlay').innerHTML = '' : '';
    document.querySelector('.product__media-list .product__media .custom-badge-overlay') ? document.querySelector('.product__media-list .product__media .custom-badge-overlay').innerHTML = '' : '';
  }

  isCustomNumberFilled() {
    //make custom number input required before saving
    let selectedFlockOption = this.querySelector('.flock-options input[name="flock-option"]:checked');
    if (selectedFlockOption && this.isPersonalizeSelectedById(selectedFlockOption.id)) {
      if (this.querySelector('#flock-personalize-number').value === '') {
        this.querySelector('.personalized-number-alert').classList.remove('hidden');
        setTimeout(() => {
          this.querySelector('.personalized-number-alert').classList.add('hidden');
        }, 5000);
        return false;
      }
      else {
        this.querySelector('.personalized-number-alert').classList.add('hidden');
        return true;
      }
    }
    return true;
  }

  isPlayerSelected() {
    //Check if second flock is selected with players dropdown, make sure at least one player is selected before saving
    let selectedFlockOption = this.querySelector('.flock-options input[name="flock-option"]:checked');
    if (selectedFlockOption) {
      if (this.isPlayersOptionById(selectedFlockOption.id)) {
        const container = this.querySelector('#' + selectedFlockOption.id + '-option');
        if (container && container.querySelector('.selected-player-name .player-info')) {
          return true;
        }
        else {
          const alert = container ? container.querySelector('.select-player-alert') : null;
          alert && alert.classList.remove('hidden');
          setTimeout(() => {
            alert && alert.classList.add('hidden');
          }, 5000);
          return false
        }
      }
    }
    return true;
  }

  resetConfigurator() {
    //reset flock
    let flockDefaultOption = this.querySelectorAll('input[name="flock-option"]');
    flockDefaultOption.length > 0 ? flockDefaultOption[0].checked = true : null;
    this.resetPlayersDropdown();

    //hide any open flock options
    if(!document.querySelectorAll('.configurator-block.legend-flock-option').length > 0) {
      this.HideAllFlockOptions();
    }

    //reset personalized inputs
    let flockPersonalizeEle = this.querySelectorAll('input[name="flock-personalize"]');
    flockPersonalizeEle.forEach(function (option) { option.value = ''; })
    this.querySelector('.required-field') && this.querySelector('.required-field').classList.add('hidden');

    //reset badges
    let badgeDefaultOption = this.querySelectorAll('input[name="badge-option"]');
    badgeDefaultOption.length > 0 ? badgeDefaultOption[0].checked = true : null;

    //reset jersey preview image
    document.querySelector('.product__media-list .product__media .personalized-flock .number').innerHTML = '';
    document.querySelector('.product__media-list .product__media .personalized-flock .name').innerHTML = '';
    document.querySelector('.image-configurator-thumbnail') && document.querySelector('.image-configurator-thumbnail').classList.add('hidden');
    document.querySelector('.configurator-image-preview') && document.querySelector('.configurator-image-preview').classList.add('hidden');
    // let ImageDefaultSelect = document.querySelectorAll('.thumbnail-list li');
    let ImageDefaultSelect = document.querySelectorAll('.thumbnail-list__item:not(.image-configurator-thumbnail)');
    if (ImageDefaultSelect.length > 1) {
      ImageDefaultSelect[0].querySelector('button').click();
    }
  }

  resetPlayersDropdown() {
    const selectedPlayerNameLabelJson = document.querySelector('[jersey-json-data]');
    const selectedPlayerNameLabel = JSON.parse(selectedPlayerNameLabelJson.innerHTML).selectedPlayerNameLabel;
    this.querySelectorAll('.selected-player-name').forEach(function (el) {
      el.innerHTML = selectedPlayerNameLabel;
    })
  }

  pickPlayer(triggeredBy) {
    const li = triggeredBy.currentTarget.closest('li') || triggeredBy.currentTarget;
    if (li.hasAttribute('number')) {
      if (li.getAttribute('number') != '')
        this.writeNumberOnJersey(li.getAttribute('number'), '', this);
    }
    if (li.hasAttribute('name')) {
      if (li.getAttribute('name') != '')
        this.writeNameOnJersey(li.getAttribute('name'));
    }
    const container = li.closest('.flock-players-options');
    if (container && container.querySelector('.selected-player-name'))
      container.querySelector('.selected-player-name').innerHTML = li.outerHTML;
    this.togglePlayersDropdown(null, true);
  }

  // Trigger variant change to update button state (for legend flock)
  triggerVariantChange() {
    const legendFlockOption = document.querySelector('.legend-flock-option');
    if (!legendFlockOption) return;

    // Find the variant-radios or variant-selects element and dispatch a change event
    const variantSelector = document.querySelector('variant-radios, variant-selects');
    if (variantSelector) {
      const checkedInput = variantSelector.querySelector('input:checked') || variantSelector.querySelector('select');
      if (checkedInput) {
        console.log('[triggerVariantChange] Dispatching change event on variant selector');
        checkedInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }
  }

  togglePlayersDropdown(event, isHide = false) {
    if (isHide) {
      this.querySelectorAll('.flock-players-options .players-container').forEach(function (pc) { pc.classList.add('hidden'); });
      this.querySelectorAll('.flock-players-options').forEach(function (fp) { fp.classList.remove('opened'); });
    } else {
      const container = event ? event.target.closest('.flock-players-options') : null;
      if (!container) return;
      this.querySelectorAll('.flock-players-options').forEach(function (fp) {
        if (fp !== container) {
          fp.classList.remove('opened');
          const pc = fp.querySelector('.players-container');
          pc && pc.classList.add('hidden');
        }
      }.bind(this));
      const playersContainer = container.querySelector('.players-container');
      if (playersContainer) playersContainer.classList.toggle('hidden');
      container.classList.toggle('opened');
    }
  }

  toggleFlockHandler(triggeredBy) {
    this.HideAllFlockOptions();
    const targetBlock = this.querySelector('#' + triggeredBy.target.id + '-option');
    if (targetBlock) {
      targetBlock.classList.remove('hidden');
    }
  }

  HideAllFlockOptions() {
    this.querySelectorAll('.flock-option-block').forEach(function (flock_option) {
      flock_option.classList.add('hidden');
    })
  }

  showSelectedOptions() {
    this.querySelector('.flock-options input[name="flock-option"]:checked') && this.querySelector('.flock-options input[name="flock-option"]:checked').click();
    this.querySelector('.badge-options input[name="badge-option"]:checked') && this.querySelector('.badge-options input[name="badge-option"]:checked').click();
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role'))
      this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('configuratorDrawer');
        const focusElement =
          this.querySelector('.drawer__inner') ||
          this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
    this.showSelectedOptions();
  }

  close(isSaving = false) {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
    if (!isSaving || typeof isSaving === 'object') {
      this.resetConfigurator();
      this.clearJerseyPersonalizedData();
      this.clearJerseyBadges();
      this.resetConfigurator();
      this.removeFormInput();
      this.updateInputMaxLenText(null);
      // Trigger variant change to update button state (for legend flock)
      this.triggerVariantChange();
    }
    this.updatePrice();
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute(
        'aria-controls',
        cartDrawerNote.nextElementSibling.id
      );
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute(
        'aria-expanded',
        !event.currentTarget.closest('details').hasAttribute('open')
      );
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);
      sectionElement.innerHTML = this.getSectionInnerHTML(
        parsedState.sections[section.id],
        section.selector
      );
    });

    setTimeout(() => {
      this.querySelector('#configuratorDrawer-Overlay').addEventListener(
        'click',
        this.close.bind(this)
      );
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'configurator-drawer',
        selector: '#configuratorDrawer',
      }
    ];
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('configurator-drawer', configuratorDrawer);
